import React, { useEffect } from 'react';
import {
  Box, Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import FaerbungReviewTable from './FaerbungReviewTable';
import { DigitalCase } from '../../../../redux/types';
import { useAppDispatch, useAppSelector } from '../../../../hooks/reduxHooks';
import { selectFaerbungReviewScoreByCaseId, selectSelectedFaerbungReviewMeta } from '../../../../redux/reducers/FaerbungReviewReducer';
import { fetchFaerbungReviewMetas, fetchFaerbungReviewScores, resetFaerbungReviewMetas } from '../../../../redux/actions/faerbungReviewAction';

type Props = {
  surveyId: number;
  sectionId: number;
  caseList: DigitalCase[];
  enrollmentId: number;
};

const FaerbungReview: React.FC<Props> = ({
  surveyId,
  sectionId,
  caseList,
  enrollmentId,
}: Props) => {
  const dispatch = useAppDispatch();
  const faerbungReviewMeta = useAppSelector(
    (state) => selectSelectedFaerbungReviewMeta(state, sectionId),
  );
  const faerbungScoresByCaseId = useAppSelector(
    (state) => selectFaerbungReviewScoreByCaseId(state),
  );

  useEffect(() => {
    dispatch(fetchFaerbungReviewMetas(surveyId));
    dispatch(fetchFaerbungReviewScores(surveyId, enrollmentId));
    return () => {
      dispatch(resetFaerbungReviewMetas());
    };
  }, [dispatch, surveyId, enrollmentId]);

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        <FormattedMessage id="review.faerbungReviewTitle" />
      </Typography>
      {
        faerbungReviewMeta && (
          <FaerbungReviewTable
            caseList={caseList}
            faerbungReviewMeta={faerbungReviewMeta}
            faerbungScoresByCaseId={faerbungScoresByCaseId}
            editMode={false}
            enrollmentId={enrollmentId}
          />
        )
      }
    </Box>
  );
};

export default FaerbungReview;
